import { unwrapPrefixedAbsoluteMediaUrl } from './unwrapPrefixedAbsoluteMediaUrl';

export interface ImageOptions {
  type?: 'hero' | 'thumb' | 'normal';
  facegravity?: boolean;
  fullwidth?: boolean;
  height?: number;
  width?: number;
}

const transformImage = (
  publicId: string,
  options: ImageOptions = { type: 'normal' },
  srcUrl?: string,
): string | null => {
  const rawUrl = publicId ? publicId : srcUrl;
  if (!rawUrl) return null;
  const imageUrl = unwrapPrefixedAbsoluteMediaUrl(rawUrl);

  const transformations = getCloudinaryFilters(options);

  if (imageUrl.includes('res.cloudinary.com')) {
    return insertCloudinaryTransformations(imageUrl, transformations);
  } else if (publicId && !publicId.includes('wp-content')) {
    const cloudName = 'highereducation';
    const image = `${imageUrl}.jpg`;
    return `https://res.cloudinary.com/${cloudName}/image/upload/${transformations}/v1/${image}`;
  } else {
    return imageUrl;
  }
};

const getCloudinaryFilters = (options: ImageOptions): string => {
  let transformations = `c_fill,f_auto,fl_lossy,q_auto`;
  switch (options.type) {
    case 'hero':
      transformations += options.fullwidth ? ',w_992,h_384' : ',w_448,h_382';
      transformations += options.facegravity ? ',g_face' : ',g_center';
      break;
    case 'thumb':
      transformations += ',w_50,h_50,g_face';
      break;
    default:
      transformations += ',g_center';
      transformations += options.width ? `,w_${options.width}` : '';
      transformations += options.height ? `,h_${options.height}` : ',h_512';
      break;
  }
  return transformations;
};

function insertCloudinaryTransformations(
  url: string,
  transformations: string,
): string {
  const transforms = url.match(/(images|upload)\/(.*?)(\/v)/);
  if (transforms) {
    return url.replace(transforms[2], transformations);
  } else {
    return url.replace(/(images|upload)\/(.*?)v/, `$1/${transformations}/v`);
  }
}

export default transformImage;
